export const merchItems = [
  {
    id: '1',
    name: 'Dragon Rider Tee',
    category: 'clothing',
    coverImage:
      'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 28.99,
    stockStatus: 'in-stock',
    releaseDate: '2024-01-15',
    description: 'Soft cotton tee with dragon rider graphic.',
  },
  {
    id: '2',
    name: 'Bookish Hoodie',
    category: 'clothing',
    coverImage:
      'https://images.unsplash.com/photo-1556821840-3a63f15732ce?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 54.99,
    stockStatus: 'in-stock',
    releaseDate: '2024-01-20',
    description: 'Cozy hoodie for readers.',
  },
  {
    id: '3',
    name: 'Fantasy Map Tee',
    category: 'clothing',
    coverImage:
      'https://images.unsplash.com/photo-1503341504253-dff4815485f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 26.99,
    stockStatus: 'low-stock',
    releaseDate: '2024-02-01',
    description: 'Vintage-style fantasy map print.',
  },
  {
    id: '4',
    name: 'Enamel Book Stack Pin',
    category: 'accessories',
    coverImage:
      'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 12.99,
    stockStatus: 'in-stock',
    releaseDate: '2024-01-10',
    description: 'Cute enamel pin of a book stack.',
  },
  {
    id: '5',
    name: 'Dragon Bookmark Set',
    category: 'accessories',
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 9.99,
    stockStatus: 'in-stock',
    releaseDate: '2024-01-12',
    description: 'Set of 5 illustrated dragon bookmarks.',
  },
  {
    id: '6',
    name: 'Tote Bag — Read More',
    category: 'accessories',
    coverImage:
      'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 18.99,
    stockStatus: 'in-stock',
    releaseDate: '2024-02-10',
    description: 'Canvas tote with "Read More" slogan.',
  },
  {
    id: '7',
    name: 'Fantasy Map Art Print',
    category: 'art-prints',
    coverImage:
      'https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 22.99,
    stockStatus: 'in-stock',
    releaseDate: '2024-01-05',
    description: '11x14 fantasy world map art print.',
  },
  {
    id: '8',
    name: 'Character Portrait Print',
    category: 'art-prints',
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 19.99,
    stockStatus: 'in-stock',
    releaseDate: '2024-01-08',
    description: 'Official character portrait, signed.',
  },
  {
    id: '9',
    name: 'Series Cover Print Set',
    category: 'art-prints',
    coverImage:
      'https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    price: 34.99,
    stockStatus: 'out-of-stock',
    releaseDate: '2023-12-01',
    description: 'Set of 3 cover art prints, 8x10.',
  },
  {
    id: '10',
    name: 'Bookish Candle — Parchment & Ink',
    category: 'home-living',
    coverImage:
      'https://images.unsplash.com/photo-1602607144535-11be3f0c3b7b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 16.99,
    stockStatus: 'in-stock',
    releaseDate: '2024-02-05',
    description: 'Soy candle with parchment and old book scent.',
  },
  {
    id: '11',
    name: 'Dragon Mug',
    category: 'home-living',
    coverImage:
      'https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 14.99,
    stockStatus: 'in-stock',
    releaseDate: '2024-01-25',
    description: '15oz ceramic mug with dragon handle detail.',
  },
  {
    id: '12',
    name: 'Fantasy Throw Blanket',
    category: 'home-living',
    coverImage:
      'https://images.unsplash.com/photo-1580301762395-21ce84d00bc6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 44.99,
    stockStatus: 'low-stock',
    releaseDate: '2024-02-15',
    description: 'Soft fleece blanket with map print.',
  },
]
